import styled from "styled-components";
import * as colors from "src/styles/constants/colors";
import * as spacing from "src/styles/constants/spacing";

export const UserCellContainer = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 100%;
`;

export const UserInfo = styled.div`
  display: flex;
  align-items: center;
  gap: ${spacing.space_s};
  flex: 1;
  min-width: 0;
`;

export const ImageLabel = styled.span`
  display: flex;
  align-items: center;
  flex-shrink: 0;

  > img,
  > div:first-of-type {
    vertical-align: middle;
    margin-right: ${spacing.space_s};
    border-radius: 50%;
  }
`;

export const AuthorWrapper = styled.div`
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  min-width: 0;
  flex: 1;
  cursor: pointer;
`;

export const GroupsContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  line-height: 1.5;
  margin-top: 14px;
`;

export const GroupsInnerDiv = styled.div`
  display: flex;
  align-items: center;
`;

export const RoleContainer = styled.div`
  display: flex;
  align-items: center;
  height: 100%;
  margin-top: 7px;

  select {
    width: 100%;
    min-width: 120px;
    padding: 5px;
  }
`;

export const OptionsContainer = styled.div`
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  border: 1px solid ${colors.grey1};
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  min-width: 150px;
`;

export const OptionsList = styled.ul`
  list-style: none;
  margin: 0;
  padding: 4px 0;
`;

export const OptionsItem = styled.li`
  padding: 8px 16px;
  cursor: pointer;
  &:hover {
    background: ${colors.grey0};
  }
`;

export const InvitingUserButton = styled.div<{ loading: boolean }>`
  > button {
    margin-left: 0.5em;
    padding: 4px 8px;
    font-size: 0.5625rem;
    background: ${(props) =>
      props.loading ? colors.active : colors.brightLight};
    color: ${(props) => (props.loading ? colors.brightLight : colors.active)};
    transition: all 0.8 ease;
    text-transform: uppercase;
    :hover,
    :focus {
      outline: none !important;
      box-shadow: none;
      background: ${colors.active};
      transition: all 0.3s ease;
      color: ${colors.brightLight};
    }
  }
`;
